var _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrackingTool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 3.74999H28.3335C29.7142 3.74999 30.8335 4.86928 30.8335 6.24999V9.48717V33.75C30.8335 35.1307 29.7142 36.25 28.3335 36.25H11.6668C10.2861 36.25 9.16683 35.1307 9.16683 33.75V6.24999C9.16683 4.86928 10.2861 3.74999 11.6668 3.74999Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.8372,
    y: 5.90627,
    width: 6.32532,
    height: 0.854167,
    rx: 0.427083,
    stroke: "#2E2E2E",
    strokeWidth: 0.854167
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.07601,
    y: 30.0455,
    width: 21.6458,
    height: 0.854167,
    rx: 0.427083,
    stroke: "#2E2E2E",
    strokeWidth: 0.854167
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.375,
    y: 32.583,
    width: 1.25,
    height: 1.25,
    rx: 0.625,
    stroke: "#2E2E2E",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 25.4167L25.8332 25.4167",
    stroke: "currentColor",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8992 23.75C15.0484 19.2418 13.3191 11.4633 19.8992 11.25",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1008 23.75C24.9516 19.2418 26.6809 11.4633 20.1008 11.25",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9998,
    cy: 15.7996,
    r: 1.37255,
    stroke: "currentColor",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingTool);
export default __webpack_public_path__ + "static/media/Tracking Tool.60b14b7dd6a935b6971dfc1f9b0fd30e.svg";
export { ForwardRef as ReactComponent };